<template>
  <div class="book-list-box">
    <div v-if="bookData.total!=0" class="book-list">
      <div @click="goDetail($event,item.id)" class="book-item" v-for="(item) of bookData.list " :key="item.id">
        <div class="book-cover">
          <!-- 默认图片 -->
          <img v-if="!item.coverPath"
            src="https://nspt.bdstatic.com/76f2f351-ef04-4d86-8fab-29b222d6ec64.png@w_228,h_152" alt="">
          <img v-if="item.coverPath" :src="item.coverPath" alt="">
          <div v-if="item.toll==1" class="book-pay">免费</div>
          <div v-if="item.toll==2" class="book-pay">收费</div>
        </div>

        <div class="book-information">
          <div>
            <div class="book-name">{{item.name}}</div>
            <div class="book-msg">
              <span>册别：</span>
              <span>{{item.volume}}</span>
            </div>
            <div class="book-msg">
              <span>出版：</span>
              <span>{{item.edition}}</span>
            </div>
            <div class="book-msg">
              <span>年级：</span>
              <span>{{item.grade}}</span>
            </div>
            <div class="book-msg">
              <span>语种：</span>
              <span>{{item.language}}</span>
            </div>
          </div>
          <div v-show="!isCollect(item.id)" @click.stop="addBookRack(item.id,1)" class="add-bookrack">添加到收藏</div>
          <div v-show="isCollect(item.id)" @click.stop="addBookRack(item.id,2)"
            class="add-bookrack add-bookrack-active">
            已添加到收藏</div>
        </div>
      </div>
    </div>

    <NoData v-show="!loading" v-else />
  </div>

</template>

<script>
import {
  userFavorite,
  isFavoriteList,
  delFavorite
} from "@/network/resourceRequest/api";
import utils from "@/util/index";
import NoData from "@/components/common/NoData";
export default {
  name: "BookList",
  components: {
    NoData
  },
  props: {
    bookData: {},
    loading: {}
  },
  data() {
    return {
      //收藏列表--------------------------------------------
      collectList: []
    };
  },

  methods: {
    //跳转详情页--------------------------------------------
    goDetail(e, id) {
      this.$router.push({
        path: "/resource-detail",
        query: { id, type: "ebook" }
      });
    },

    //添加书架--------------------------------------------
    addBookRack(id, type) {
      if (!this.$store.state.isLogin) return utils.tipsLogin();

      //添加收藏--------------------------------------------
      if (type == 1) {
        userFavorite(id).then(res => {
          if (res.data.success) {
            this.collectList.push(id);
            utils.tips("success", "添加成功");
          }
        });
      }

      //取消收藏--------------------------------------------
      if (type == 2) {
        delFavorite(id).then(res => {
          if (res.data.success) {
            this.collectList.splice(this.collectList.indexOf(id), 1);
            utils.tips("success", "取消成功");
          }
        });
      }
    },

    //是否收藏--------------------------------------------
    isCollect(id) {
      return this.collectList.includes(id);
    },

    //更新是否收藏的列表--------------------------------------------
    updateFavoriteList(dataList) {
      this.collectList = [];
      let resourceList = [];
      dataList.list.forEach(item => {
        resourceList.push(item.id);
      });
      let str = resourceList.join(",");
      let data = {
        resourceIds: str
      };

      isFavoriteList(data).then(res => {
        if (res.data.success) {
          this.collectList = res.data.data;
        }
      });
    }
  },

  watch: {
    bookData(newValue) {
      this.updateFavoriteList(newValue);
    }
  }
};
</script>

<style lang='less' scoped>
.book-list {
  padding: 35px 20px;
  display: flex;
  flex-wrap: wrap;

  .book-item {
    user-select: none;
    display: flex;
    margin: 0 20px 20px 0;
    border-radius: 5px;
    overflow: hidden;

    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);

    width: 293px;
    height: 180px;

    .book-cover {
      position: relative;
      width: 135px;

      img {
        width: 100%;
        height: 100%;
      }

      .book-pay {
        position: absolute;
        right: 10px;
        bottom: 10px;

        box-sizing: content-box;
        border: 2px solid rgba(255, 255, 255, 1);
        border-radius: 14px;
        width: 60px;
        height: 28px;

        font-size: 12px;
        font-size: 12px;
        font-weight: 400;
        line-height: 28px;
        text-align: center;

        color: rgba(255, 255, 255, 1);
        background: #24ba58;
      }

      .book-free {
        position: absolute;
        right: 10px;
        bottom: 10px;

        box-sizing: content-box;
        border: 2px solid rgba(255, 255, 255, 1);
        border-radius: 14px;
        width: 60px;
        height: 28px;

        font-size: 12px;
        font-size: 12px;
        font-weight: 400;
        line-height: 28px;
        text-align: center;

        color: rgba(255, 255, 255, 1);
        background: #f27979;
      }
    }

    .book-information {
      padding: 10px;
      padding-left: 15px;
      width: 159px;

      .book-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        font-size: 14px;
        font-weight: 400;

        color: #24ba58;
      }

      .book-msg {
        display: flex;

        margin: 9px 0;

        font-size: 12px;

        color: rgba(102, 102, 102, 1);

        span {
          white-space: nowrap;
        }

        span:nth-child(2) {
          overflow: hidden;

          white-space: nowrap;
          text-overflow: ellipsis;

          color: #333;
        }
      }

      .add-bookrack {
        border: 1px solid #24ba58;
        border-radius: 5px;
        height: 28px;

        font-size: 12px;
        line-height: 28px;
        text-align: center;
        letter-spacing: 1.5px;

        color: #24ba58;
        background-color: #fff;

        cursor: pointer;

        &:hover {
          background: #24ba58;
          color: #fff;
        }
      }

      .add-bookrack-active {
        background: #24ba58;
        color: #fff;

        &:hover {
          background: #24ba00;
        }
      }
    }

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  .book-item:hover {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
    transform: translateY(-1px);
  }
}
</style>